var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaystack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_2612)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_914_2612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.779297 0H20.0949V19H0.779297V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_914_2612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0881 0H1.7827C1.23082 0 0.779297 0.45237 0.779297 1.0053V2.81481C0.779297 3.36773 1.23082 3.8201 1.7827 3.8201H18.0379C18.5898 3.8201 19.0413 3.36773 19.0413 2.81481V1.0053C19.0915 0.45237 18.64 0 18.0881 0ZM18.0881 10.1032H1.7827C1.23082 10.1032 0.779297 10.5555 0.779297 11.1085V12.918C0.779297 13.4709 1.23082 13.9233 1.7827 13.9233H18.0379C18.5898 13.9233 19.0413 13.4709 19.0413 12.918V11.1085C19.0915 10.5555 18.64 10.1032 18.0881 10.1032ZM10.9639 15.1799H1.7827C1.23082 15.1799 0.779297 15.6323 0.779297 16.1852V17.9947C0.779297 18.5476 1.23082 19 1.7827 19H10.9639C11.5158 19 11.9673 18.5476 11.9673 17.9947V16.1852C11.9673 15.6323 11.5158 15.1799 10.9639 15.1799ZM19.0915 5.07672H1.7827C1.23082 5.07672 0.779297 5.52909 0.779297 6.08199V7.89153C0.779297 8.44443 1.23082 8.89683 1.7827 8.89683H19.0915C19.6434 8.89683 20.0949 8.44443 20.0949 7.89153V6.08199C20.0949 5.52909 19.6434 5.07672 19.0915 5.07672Z",
    fill: "#0BA4DB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_2612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3156,
    height: 19,
    fill: "white",
    transform: "translate(0.779297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.0348cf92fa1876fae2d606c5069f2dc0.svg";
export { ForwardRef as ReactComponent };